import React, { useState, useEffect, useRef, useCallback } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {
  ErrorDisplay,
  Loading,
  SuccessDisplay,
  DataGrid,
} from '../../components'
import { GSXService } from '../../services'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers, validations } from '../../components'

const ArticleContent = ({ title, content, id, hideMore }) => {
  const contentArticles = useRef()
  const [child, setChild] = useState(null)
  const [isIframeChild, setIsIframeChild] = useState(false)
  const [loadingChild, setLoadingChild] = useState(false)
  const [errors, setErrors] = useState(false)
  const [open, setOpen] = useState(false)
  const validURL = (str) => {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator
    return !!pattern.test(str)
  }

  useEffect(() => {
    const anchors =
      contentArticles.current.children[1].getElementsByTagName('a')
    for (let index = 0; index < anchors.length; index++) {
      const element = anchors[index]
      const href = element.getAttribute('href')
      if (href && href.indexOf('#') === -1) {
        element.addEventListener('click', function (e) {
          e.preventDefault()
          if (validURL(href)) {
            setChild(href)
            setIsIframeChild(true)
            window.open(
              href,
              element.text,
              'width=550,height=500,left=150,top=200,toolbar=0,status=0,'
            )
          } else {
            getArticle(href)
          }

          return false
        })
      }
    }
  }, [title, content, id])
  const getArticle = (articleID) => {
    setOpen(true)
    setLoadingChild(true)
    setIsIframeChild(false)
    new GSXService()
      .content_article({ articleId: articleID })
      .then((response) => {
        setChild(response)
        setLoadingChild(false)
      })
      .catch((errors) => {
        setLoadingChild(false)
        setErrors(errors)
        setChild(null)
      })
  }

  const closeModal = () => {
    setOpen(false)
    setChild(null)
    setErrors(null)
  }
  return (
    <>
      {loadingChild || child || errors ? (
        <ReactBootstrap.Modal
          size="xl"
          backdrop="static"
          show={open}
          onHide={(e) => closeModal()}
        >
          <ReactBootstrap.Modal.Header
            className="bg-dark text-white"
            closeButton
          >
            <ReactBootstrap.Modal.Title>{`${
              child ? child.title : 'Loading'
            }`}</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {loadingChild && !child ? <Loading /> : ''}
            {errors ? <ErrorDisplay error={errors} /> : ''}
            {child && child.body && !isIframeChild ? (
              <ArticleContent
                hideMore={true}
                id={id}
                title={child.title}
                content={child.description}
              />
            ) : (
              ''
            )}
            {child && child.description && !isIframeChild ? (
              <ArticleContent
                hideMore={true}
                id={id}
                title={child.title}
                content={child.description}
              />
            ) : (
              ''
            )}
            {/* {isIframeChild?<iframe title="child" src={child}/>:''} */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      ) : (
        ''
      )}
      <div ref={contentArticles} name="content_gsx_article">
        <p>
          <strong>
            {id} : {title}
          </strong>
        </p>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
      {id && !hideMore ? (
        <ReactBootstrap.Button variant="dark" onClick={() => getArticle(id)}>
          Read More...
        </ReactBootstrap.Button>
      ) : (
        ''
      )}
    </>
  )
}

const ContentLookUpResult = ({ data, onTableChange, sizePerPage, count }) => {
  const renderLookupResult = (cell, row) => {
    return <ArticleContent id={row.id} title={cell} content={row.summary} />
  }

  const columns = [
    {
      dataField: 'title',
      text: 'Title',
      type: 'string',
      formatter: renderLookupResult,
    },
  ]
  return (
    <DataGrid
      keyField={'id'}
      sizePerPage={sizePerPage}
      headerWrapperClasses="d-none"
      count={count}
      onTableChange={onTableChange}
      data={data}
      columns={columns}
    />
  )
}

const ContentLookUpSearchFormHTML = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col>
        <Field
          name="searchString"
          component={renderers.renderField}
          type="text"
          label="Search String"
          validate={[validations.required]}
        />
      </ReactBootstrap.Col>
      <ReactBootstrap.Col>
        <FormButtons
          submitting={submitting}
          pristine={pristine}
          reset={reset}
        />
      </ReactBootstrap.Col>
    </form>
  )
}

const ContentLookUpSearchForm = reduxForm({
  form: 'ContentLookUpSearchFormHTML', // a unique identifier for this form
})(ContentLookUpSearchFormHTML)

export const ContentLookUpResultModal = ({ filter, displayText, inline }) => {
  const [show, setShow] = useState(false)
  const [sizePerPage] = useState(10)
  const [loading, setLoading] = useState([])
  const [articles, setArticles] = useState([])
  const [totalNumberOfRecords, setTotalNumberOfRecords] = useState(0)
  const [errors, setErrors] = useState([])
  const handleClose = () => setShow(false)

  const handleShow = useCallback(
    (type, f) => {
      let data = {
        pageNumber: 1,
        sizePerPage: sizePerPage,
        search_criteria: filter,
      }

      if (f) {
        const { page, sizePerPage, filters } = f
        data.pageNumber = page
        data.sizePerPage = sizePerPage
        if (filters) {
          data.search_criteria = { ...filters, ...data.search_criteria }
        }
      }

      setShow(true)
      setLoading(true)
      new GSXService()
        .content_article_lookup(data)
        .then((response) => {
          setArticles(response.articles)
          setTotalNumberOfRecords(response.totalNumberOfRecords)
          setLoading(false)
          setErrors(null)
        })
        .catch((errors) => {
          setArticles([])
          setTotalNumberOfRecords(0)
          setLoading(false)
          setErrors(errors)
        })
    },
    [
      sizePerPage,
      filter,
      setArticles,
      setTotalNumberOfRecords,
      setLoading,
      setErrors,
    ]
  )

  useEffect(() => {
    if (inline) {
      handleShow()
    }
  }, [filter, displayText, inline, handleShow])

  if (!inline)
    return (
      <>
        <ReactBootstrap.Modal
          size="xl"
          backdrop="static"
          show={show}
          onHide={handleClose}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              {displayText}
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            {loading ? <Loading /> : ''}
            {errors && !loading ? <ErrorDisplay error={errors} /> : ''}
            {articles ? (
              <ContentLookUpResult
                sizePerPage={sizePerPage}
                onTableChange={handleShow}
                data={articles}
                count={totalNumberOfRecords}
              />
            ) : (
              <SuccessDisplay message={'No Previous repair found.'} />
            )}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer></ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>

        <ReactBootstrap.NavDropdown.Item
          onClick={(e) => {
            handleShow()
          }}
        >
          <i class="fa fa-edit" aria-hidden="true"></i> {displayText}
        </ReactBootstrap.NavDropdown.Item>
      </>
    )

  return (
    <>
      <ContentLookUpSearchForm
        onSubmit={(values) => handleShow(null, { page: 1, filters: values })}
      />
      <br /> <br />
      <ReactBootstrap.Card>
        <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
          {`GSX Articles (${totalNumberOfRecords})`}
        </ReactBootstrap.Card.Header>
        <ReactBootstrap.Card.Body>
          {loading ? <Loading /> : ''}
          {errors && !loading ? <ErrorDisplay error={errors} /> : ''}
          <ReactBootstrap.Col>
            <ContentLookUpResult
              sizePerPage={sizePerPage}
              onTableChange={handleShow}
              data={articles}
              count={totalNumberOfRecords}
            />
          </ReactBootstrap.Col>
        </ReactBootstrap.Card.Body>
      </ReactBootstrap.Card>
    </>
  )
}
